module.exports = __webpack_public_path__ + "img/1-sun.fbf9dc2.png";